import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword"; // ✅ ADD
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Vehicles from "./pages/Vehicles";
import Bookings from "./pages/Bookings";
import Drivers from "./pages/Drivers";
import GPSTracking from "./pages/GPSTracking";
import AnalyticsReports from "./pages/AnalyticsReports";
import MarketingCampaigns from "./pages/MarketingCampaigns";
import Settings from "./pages/Settings";
import AuditTrails from "./pages/AuditTrails";
import Unauthorized from "./pages/Unauthorized";
import ProtectedRoute from "./routes/ProtectedRoute";
import ForgotPasswordVerify from "./pages/ForgotPasswordVerify";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} /> {/* ✅ ADD */}
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/forgot-password/verify" element={<ForgotPasswordVerify />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute routeKey="changePassword">
              <ChangePassword />
            </ProtectedRoute>
          }
        />


        {/* PROTECTED */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute routeKey="dashboard">
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute routeKey="users">
              <Users />
            </ProtectedRoute>
          }
        />

        <Route
          path="/vehicles"
          element={
            <ProtectedRoute routeKey="vehicles">
              <Vehicles />
            </ProtectedRoute>
          }
        />

        <Route
          path="/bookings"
          element={
            <ProtectedRoute routeKey="bookings">
              <Bookings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics-reports"
          element={
            <ProtectedRoute routeKey="analyticsReports">
              <AnalyticsReports />
            </ProtectedRoute>
          }
        />

        <Route
          path="/marketing-campaigns"
          element={
            <ProtectedRoute routeKey="marketingCampaigns">
              <MarketingCampaigns />
            </ProtectedRoute>
          }
        />

        <Route
          path="/drivers"
          element={
            <ProtectedRoute routeKey="drivers">
              <Drivers />
            </ProtectedRoute>
          }
        />

        <Route
          path="/gps-tracking"
          element={
            <ProtectedRoute routeKey="gpsTracking">
              <GPSTracking />
            </ProtectedRoute>
          }
        />

        <Route
          path="/gps-tracking/:bookingId"
          element={
            <ProtectedRoute routeKey="gpsTracking">
              <GPSTracking />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute routeKey="settings">
              <Settings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/audit-trails"
          element={
            <ProtectedRoute routeKey="auditTrails">
              <AuditTrails />
            </ProtectedRoute>
          }
        />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
